import { Form, Input, Button, Row, Col, Radio, Select, DatePicker, Checkbox, Upload, message, Tooltip, Popconfirm } from 'antd';
import "./style.css"
import { LinkOutlined, QuestionCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { buscarCEP, buscarClienteReceitaFederal, Method_POST_CONTEXTO, POST_MERP_REST } from '../../../../../service/api';
import { useEffect, useState, useCallback } from 'react';

import listUF from '../../../../../function/helpers/listUF.json'
import { formatarDataParaISO, formatValueBrl, limparFormatValueBrl } from '../../../../../function/utilis/function';
import dayjs from 'dayjs';

const { TextArea } = Input;
const { Search } = Input;

const mesesOptions = [
    { value: 1, label: 'Janeiro' },
    { value: 2, label: 'Fevereiro' },
    { value: 3, label: 'Março' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Maio' },
    { value: 6, label: 'Junho' },
    { value: 7, label: 'Julho' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Setembro' },
    { value: 10, label: 'Outubro' },
    { value: 11, label: 'Novembro' },
    { value: 12, label: 'Dezembro' },
];

const AtualizarDadosEmpresa = ({ clienteSelecionado }) => {
    const [form] = Form.useForm();
    const [carteirasOptions, setCarteirasOptions] = useState([]);
    const [equipesOptions, setEquipesOptions] = useState([]);
    const [esconderSituacaoIE, setEsconderSituacaoIE] = useState(false);
    const [esconderSituacaoIM, setEsconderSituacaoIM] = useState(false);
    const [openPopconfirm, setOpenPopconfirm] = useState(false);
    const enquadramentoSelecionado = form.getFieldValue('enquadramento');
    const isFaturamentoDisabled = enquadramentoSelecionado === "MEI";
    const [loadingSearchCep, setLoadingSearchCep] = useState(false);

    const [pendingChange, setPendingChange] = useState({
        fieldName: undefined,
        newValue: undefined,
        currentValue: undefined
    });

    const handlePopconfirmChange = (fieldName, value) => {
        setPendingChange({
            fieldName: fieldName,
            newValue: value,
            currentValue: form.getFieldValue(fieldName),
        });

        setOpenPopconfirm(true);
    };

    const handleEnquadramentoChange = (enquadramentoValue) => {
        handlePopconfirmChange('enquadramento', enquadramentoValue);
    };

    const handleRegimeTributarioChange = (regimeTributarioValue) => {
        handlePopconfirmChange('regimeTributario', regimeTributarioValue);
    };

    const handleSegmentoAtuacaoChange = (segmentoEmpresa) => {
        handlePopconfirmChange('segmentoEmpresa', segmentoEmpresa);
    };

    const handleFaixaFaturamentoChange = (faixaFaturamento) => {
        handlePopconfirmChange('faixaFaturamento', faixaFaturamento)
    }

    const ufOptions = listUF.map(item => ({
        value: item.uf,
        label: `${item.uf} - ${item.nome}`
    }));

    const contexto = async () => {
        try {
            const url = `contador/cliente/contexto`;
            const data = {
                id: clienteSelecionado
            };

            console.log("payload:", data);

            const response = await Method_POST_CONTEXTO(url, data);

        } catch (error) {
            console.error("Erro ao buscar analistas:", error);
        }
    }

    const buscarDadosCnpj = async () => {
        try {
            await form.validateFields(["cnpj"]);
        } catch (errorInfo) {
            message.warning("Por favor, preencha o CNPJ para buscar os dados.");
            return;
        }

        try {
            const cnpjValue = form.getFieldValue('cnpj');

            if (!cnpjValue) {
                message.error("Valor do CNPJ não encontrado no formulário.");
                return;
            }

            const cnpjFormatado = cnpjValue.replace(/[^\d]/g, '');

            const url = `/retrieve?cnpj=${cnpjFormatado}&provedor=SERPRO&_=${Date.now()}`;

            const response = await buscarClienteReceitaFederal(url);

            if (!response || response.message) {
                console.log("CNPJ não encontrado ou erro na API");
                message.error("CNPJ não encontrado ou inválido. Digite manualmente.");
                return;
            }

            if (response) {
                console.log("Mostrar dados do cnpj: ", response);

                const endereco = response.endereco || {};

                form.setFieldsValue({
                    razaoSocial: response.nomeEmpresarial,
                    capitalSocial: response.capitalSocial,
                    cep: endereco.cep,
                    logradouro: endereco.logradouro,
                    numero: endereco.numero,
                    complemento: endereco.complemento,
                    bairro: endereco.bairro,
                    cidade: endereco.municipio?.descricao,
                    uf: endereco.uf,
                });
            }
        } catch (error) {
            console.error("Erro ao buscar cliente:", error.message);
            message.error("Erro ao buscar dados do CNPJ. Tente novamente.");
        } finally {
            console.log('Busca finalizada.');
        }
    };

    const buscaCep = async (cepValueInput) => {
        setLoadingSearchCep(true);

        const cepValue = cepValueInput

        if (!cepValue) {
            message.warning("Por favor, preencha o CEP para buscar os dados.");
            setLoadingSearchCep(false);
            return;
        }

        const cepFormatado = cepValue.replace(/[^\d]/g, '');

        if (cepFormatado.length !== 8) {
            message.warning("CEP deve ter 8 dígitos.");
            setLoadingSearchCep(false);
            return;
        }

        try {
            const url = `/${cepFormatado
                }/json/?callback=jQuery351007902269989644672_1727782116159&_=${Date.now()}`;

            const response = await buscarCEP(url);

            let jsonResponse;
            if (response) {
                // Lógica para extrair o JSON do formato JSONP (jQuery callback)
                const jsonString = response.substring(
                    response.indexOf("(") + 1,
                    response.lastIndexOf(")")
                );
                jsonResponse = JSON.parse(jsonString);
            }

            if (!jsonResponse || jsonResponse.erro) {
                message.error("CEP não encontrado. Verifique e digite manualmente.");
                setLoadingSearchCep(false);
                return;
            }

            form.setFieldsValue({
                logradouro: jsonResponse.logradouro,
                bairro: jsonResponse.bairro,
                cidade: jsonResponse.localidade, // Mapeado para cidade
                uf: jsonResponse.uf, // Mapeado para UF
                // O campo 'numero' e 'complemento' não vêm do CEP, mas é bom limpá-los se o CEP for buscado
                numero: undefined,
                complemento: undefined,
            });

            message.success("Endereço preenchido com sucesso!");

        } catch (error) {
            console.error("Erro ao buscar CEP:", error.message);
        } finally {
            // 4. Finaliza o loading
            setLoadingSearchCep(false);
        }
    };

    const atualizar = async (values) => {
        try {
            console.log("Iniciando a função atualizar com os valores:", values);

            const listaMunicipios = await municipioListar(values.uf);

            const municipioSelecionado = listaMunicipios?.find(m =>
                m.nome?.toLowerCase() === values.cidade?.toLowerCase()
            );

            const ibgeMunicipioId = municipioSelecionado ? municipioSelecionado.id : null;

            if (!ibgeMunicipioId) {
                message.warning(`Não foi possível encontrar o ID IBGE para o município: ${values.cidade}.`);
            }

            const cepLimpo = values.cep ? values.cep.replace(/[^\d]/g, '') : '';

            // 1. Mapeamento e Formatação das Datas do Formulário
            const dataConstituicaoFormatada = formatarDataParaISO(values.dataConstituicao);
            const dataEncerramentoFormatada = formatarDataParaISO(values.dataEncerramento);
            const dataReenquadramentoFormatada = formatarDataParaISO(values.dataReenquadramento);
            const dataOpcaoSNFormatada = formatarDataParaISO(values.dataOpcaoSN);
            const dataNotificacaoCargaNFesFormatada = formatarDataParaISO(values.dataNotificacaoCargaNFes);

            // CORREÇÃO: Usando os nomes dos campos do formulário (inicioFolha, proLabore, terminoAdiantamento)
            const dataInicioFolhaFormatada = formatarDataParaISO(values.inicioFolha); // Ajustado: era dataInicioFolha
            const dataTerminoFolhaFormatada = formatarDataParaISO(values.dataTerminoFolha);
            const dataInicioProlaboreFormatada = formatarDataParaISO(values.dataInicioProlabore);
            const dataTerminoProlaboreFormatada = "2025-09-09T03:00:00.000Z";
            const dataInicioAdiantamentoFolhaFormatada = formatarDataParaISO(values.dataInicioAdiantamentoFolha);
            const dataTerminoAdiantamentoFolhaFormatada = formatarDataParaISO(values.terminoAdiantamento); // Ajustado: era dataTerminoAdiantamentoFolha

            const mesSelecionado = mesesOptions.find(mes => mes.value === values.dataBase);
            const dataBaseParaEnvio = mesSelecionado ? mesSelecionado.label : values.dataBase;

            const dataInicioProcuracaoFGTS = formatarDataParaISO(values.dataInicioProcuracaoFGTS);
            const dataTerminoProcuracaoFGTS = formatarDataParaISO(values.dataTerminoProcuracaoFGTS);

            const isProcuracaoAtiva = values.procuracaoFGTS === true;
            const isInicioProcuracaoFGTS = !values.dataInicioProcuracaoFGTS;
            const isTerminoProcuracaoFGTS = !values.dataTerminoProcuracaoFGTS;
            
            const isAdiantamentoFolha = values.adiantamentoFolha === true;
            const isInicioAdiantamento = !values.dataInicioAdiantamentoFolha;
            const isTerminoAdiantamento = !values.terminoAdiantamento;

            const isApuracaoManual = values.apuracaoManual === true;
            const isMotivoAlteracao = values.motivoApuracaoManual === '';

            const url = `cliente/empresa/atualizar`;

            const data = {

                adiantamentoFolha: values.adiantamentoFolha,
                adicionalNoturno: values.adicionalNoturno === 0 ? "0.00" : values.adicionalNoturno,
                apontamento: values.apontamento,
                apuracaoConfiavel: values.apuracaoConfiavel,
                apuracaoDCTFWebManual: values.apuracaoDCTFWebManual,
                apuracaoManual: values.apuracaoManual,
                capitalSocial: limparFormatValueBrl(values.capitalSocial),

                cargaNFSeAutomatica: values.cargaNFSeAutomatica,
                cargaNFes: values.cargaNFes,
                carteira: { id: String(values.carteira) },
                categoriaEmpresa: { id: values.categoriaEmpresa, nome: null },
                cestaBasica: values.cestaBasica,

                cnpj: values.cnpj,
                contabilidadeSimplificada: values.contabilidadeSimplificada,
                contribuicaoIe: values.contribuicaoIe,
                contribuicaoIm: values.contribuicaoIm,
                dataBase: values.dataBase,

                // 2. Usando as datas formatadas
                dataConstituicao: dataConstituicaoFormatada,
                dataEncerramento: dataEncerramentoFormatada,
                dataReenquadramento: dataReenquadramentoFormatada,
                dataOpcaoSN: dataOpcaoSNFormatada,
                dataNotificacaoCargaNFes: dataNotificacaoCargaNFesFormatada,
                dataInicioFolha: dataInicioFolhaFormatada, // Corrigido
                dataTerminoFolha: dataTerminoFolhaFormatada,
                dataInicioProlabore: dataInicioProlaboreFormatada,
                dataTerminoProlabore: dataTerminoProlaboreFormatada,
                dataInicioAdiantamentoFolha: dataInicioAdiantamentoFolhaFormatada,
                dataTerminoAdiantamentoFolha: dataTerminoAdiantamentoFolhaFormatada, // Corrigido

                // Campos com string vazia
                dataInicioProcuracaoFGTS: dataInicioProcuracaoFGTS,
                dataTerminoProcuracaoFGTS: dataTerminoProcuracaoFGTS,

                retencaoIss: true,
                snanexo: "",
                snregime: "",
                // FIM dos campos com string vazia

                descontoVR: values.descontoVR,
                descontoVT: values.descontoVT,
                diaLimiteApontamento: values.diaLimiteApontamento,
                diaLimiteFolha: values.diaLimiteFolha,
                dirbi: values.dirbi,

                endereco: {
                    bairro: values.bairro,
                    cep: cepLimpo,
                    cidade: values.cidade,
                    complemento: values.complemento,
                    ibgeMunicipio: {
                        id: ibgeMunicipioId,
                        nome: values.cidade,
                        uf: null,
                    },
                    inscricaoImobiliaria: values.ib || "", // Use 'ib' do form para inscricaoImobiliaria se for o caso
                    logradouro: values.logradouro,
                    numero: values.numero,
                    uf: values.uf,
                },

                enquadramento: { id: values.enquadramento },
                equipe: { id: values.equipe },
                esocial: values.esocial,
                faixaFaturamento: values.faixaFaturamento,
                faturamentoExcedido: values.faturamentoExcedido,
                folha: values.folha,
                formaAtuacao: values.formaAtuacao,
                gia: values.gia,
                horaExtra: values.horaExtra,
                // Certifique-se de que irfolha e retencaoINSS usam a referência correta (irFolha e retencaoInss)
                // Assumindo que o back-end aceita o formato snake_case, mas você precisa usar o camelCase do formulário
                ie: esconderSituacaoIE === false ? "" : values.ie,
                im: esconderSituacaoIM === false ? "" : values.im, // CORREÇÃO: Usando values.im
                irfolha: values.irFolha, // CORREÇÃO: Use values.irFolha (do form) se for o nome correto
                matriz: values.tipoCnpj === 'matriz',
                motivoApuracaoConfiavel: { id: values.motivoApuracaoConfiavel },
                motivoApuracaoManual: { id: values.motivoApuracaoManual },
                nire: values.nire,
                nivelContabil: values.nivelContabil,
                nivelFiscal: values.nivelFiscal,
                nomeFantasia: values.nomeFantasia,
                notificacaoCargaNFes: values.notificacaoCargaNFes,
                numeroFuncionarios: values.numeroFuncionarios,
                numeroFuncionariosIsentos: values.numeroFuncionariosIsentos,
                observacaoDP: values.observacaoDP,
                pisoSalarial: limparFormatValueBrl(values.pisoSalarial),
                procuracaoFGTS: values.procuracaoFGTS,
                prolabore: values.proLabore, // CORREÇÃO: Use values.proLabore (do form) se for o nome correto
                razaoSocial: values.razaoSocial,
                regimeApuracao: values.regimeApuracao,
                regimeContabil: { id: values.regimeContabil },
                regimeDP: { id: values.regimeDp }, // CORREÇÃO: Use values.regimeDp (do form)
                regimeTributario: { id: values.regimeTributario },
                retencaoINSS: values.retencaoInss, // CORREÇÃO: Use values.retencaoInss (do form)

                segmentoEmpresa: { id: values.segmentoEmpresa },
                semMovimento: values.semMovimento,
                sieg: values.sieg,
                sindicatoEmpregados: values.sindicatoEmpregados,
                sindicatoPatronal: values.sindicatoPatronal,
                sintegra: values.sintegra,
                situacaoIe: esconderSituacaoIE === true ? values.situacaoIe : "",
                situacaoIm: esconderSituacaoIM === true ? values.situacaoIm : "", // CORREÇÃO: Usando values.situacaoIm

                tipoEmpresa: { id: values.tipoEmpresa, nome: null },
                tipoPessoa: "PJ",
                valorAdicional: limparFormatValueBrl(values.valorAdicional),
                valorAssinatura: limparFormatValueBrl(values.valorAssinatura),
                valorCestaBasica: limparFormatValueBrl(values.valorCestaBasica),
                valorMensal: limparFormatValueBrl(values.valorMensal),
                vinculoSefaz: values.vinculoSefaz,
                vr: values.vr,
                vt: values.vt,

            };

            if (isAdiantamentoFolha && (isInicioAdiantamento || isTerminoAdiantamento)) {
                message.warning("Os Campos data [Início Adiantamento] e [Término Adiantamento] é obrigatório quando cliente possui adiantamento de folha.");
                return; // Bloqueia o envio
            }

            if (isProcuracaoAtiva && (isInicioProcuracaoFGTS || isTerminoProcuracaoFGTS)) {
                message.warning("Os campos [data início procuração FGTS] e [data término procuração FGTS] são obrigatórios quando o cliente possui procuração de FGTS.");
                return; // Bloqueia o envio
            }

            if (values.ie && values.segmentoEmpresa === 'PS') {
                message.warning("Campo [Segmento de Atuação] inválido! Empresa não pode ser apenas Prestadora de Serviços tendo Inscrição Estadual. Por favor, corrija.");
                return;
            }

            if (isApuracaoManual && isMotivoAlteracao) {
                message.warning("Campo [motivo apuração manual] é obrigatório quando cliente possui apuração manual.");
                return;
            }

            const response = await Method_POST_CONTEXTO(url, data);

            await consultar();
            message.success("Dados da empresa atualizados com sucesso!");

        } catch (error) {
            console.error("Erro ao atualizar dados da empresa:", error); // Corrigido o log
            message.error("Erro ao atualizar dados da empresa. Verifique o console para detalhes.");
        }
    }

    const listCarteira = useCallback(async () => {
        try {
            const url = "contador/carteira/cliente/listar";
            const response = await Method_POST_CONTEXTO(url, {});
            if (Array.isArray(response)) {
                const options = response.map(item => ({ value: item.id, label: item.nome }));
                setCarteirasOptions(options);
            } else {
                setCarteirasOptions([]);
            }
        } catch (error) {
            console.error("Erro ao buscar carteiras:", error);
        }
    }, []);

    const listEquipe = useCallback(async () => {
        try {
            const url = "contador/equipe/listar";
            const response = await Method_POST_CONTEXTO(url, {});
            if (Array.isArray(response)) {
                const options = response.map(item => ({ value: item.id, label: item.nome }));
                setEquipesOptions(options);
            } else {
                setEquipesOptions([]);
            }
        } catch (error) {
            console.error("Erro ao buscar equipes:", error);
        }
    }, []);

    const consultar = useCallback(async () => {
        try {
            //limpar os campos antes de mostrar novos dados de outro cliente;
            form.resetFields();

            const url = "cliente/empresa/consultar";

            const data = {
                id: clienteSelecionado
            }

            const response = await Method_POST_CONTEXTO(url, data);

            if (response) {
                const dadosEmpresa = response

                console.log("Dados da Empresa para preencher o Formulário:", dadosEmpresa);

                if (!dadosEmpresa || typeof dadosEmpresa !== 'object') {
                    console.error("Dados da empresa não encontrados ou formato incorreto.");
                    return;
                }

                const dataBaseValue = dadosEmpresa.dataBase !== null && dadosEmpresa.dataBase !== undefined ? Number(dadosEmpresa.dataBase) : undefined;

                const dadosParaForm = {
                    cnpj: dadosEmpresa.cnpj,
                    razaoSocial: dadosEmpresa.razaoSocial,
                    regimeApuracao: dadosEmpresa.regimeApuracao,
                    nomeFantasia: dadosEmpresa.nomeFantasia,
                    nire: dadosEmpresa.nire,
                    capitalSocial: formatValueBrl(dadosEmpresa.capitalSocial),

                    // Campos Select/Dropdown (ID)
                    carteira: dadosEmpresa.carteira ? dadosEmpresa.carteira.id : undefined,
                    equipe: dadosEmpresa.equipe ? dadosEmpresa.equipe.id : undefined,
                    tipoEmpresa: dadosEmpresa.tipoEmpresa ? dadosEmpresa.tipoEmpresa.id : undefined,
                    enquadramento: dadosEmpresa.enquadramento ? dadosEmpresa.enquadramento.id : undefined,
                    regimeTributario: dadosEmpresa.regimeTributario ? dadosEmpresa.regimeTributario.id : undefined,
                    segmentoEmpresa: dadosEmpresa.segmentoEmpresa ? dadosEmpresa.segmentoEmpresa.id : undefined,
                    categoriaEmpresa: dadosEmpresa.categoriaEmpresa ? dadosEmpresa.categoriaEmpresa.id : undefined,
                    regimeContabil: dadosEmpresa.regimeContabil ? dadosEmpresa.regimeContabil.id : undefined,
                    regimeDp: dadosEmpresa.regimeDP ? dadosEmpresa.regimeDP.id : undefined, // Assumindo regimeDP na API
                    motivoApuracaoManual: dadosEmpresa.motivoApuracaoManual ? dadosEmpresa.motivoApuracaoManual.id : undefined,
                    motivoApuracaoConfiavel: dadosEmpresa.motivoApuracaoConfiavel ? dadosEmpresa.motivoApuracaoConfiavel.id : undefined,

                    dataConstituicao: dadosEmpresa.dataConstituicao ? dayjs(dadosEmpresa.dataConstituicao) : null,
                    dataEncerramento: dadosEmpresa.dataEncerramento ? dayjs(dadosEmpresa.dataEncerramento) : null,
                    dataReenquadramento: dadosEmpresa.dataReenquadramento ? dayjs(dadosEmpresa.dataReenquadramento) : null,
                    dataOpcaoSN: dadosEmpresa.dataOpcaoSN ? dayjs(dadosEmpresa.dataOpcaoSN) : null,
                    dataNotificacaoCargaNFes: dadosEmpresa.dataNotificacaoCargaNFes ? dayjs(dadosEmpresa.dataNotificacaoCargaNFes) : null,

                    dataInicioProlabore: (dadosEmpresa.dataInicioProlabore && dadosEmpresa.dataInicioProlabore !== "0001-01-01T00:00:00") ? dayjs(dadosEmpresa.dataInicioProlabore) : null,
                    dataTerminoProlabore: dadosEmpresa.dataTerminoProlabore ? dayjs(dadosEmpresa.dataTerminoProlabore) : null,

                    dataInicioProcuracaoFGTS: dadosEmpresa.dataInicioProcuracaoFGTS ? dayjs(dadosEmpresa.dataInicioProcuracaoFGTS) : null,
                    dataTerminoProcuracaoFGTS: dadosEmpresa.dataTerminoProcuracaoFGTS ? dayjs(dadosEmpresa.dataTerminoProcuracaoFGTS) : null,

                    inicioFolha: dadosEmpresa.dataInicioFolha ? dayjs(dadosEmpresa.dataInicioFolha) : null,
                    dataTerminoFolha: dadosEmpresa.dataTerminoFolha ? dayjs(dadosEmpresa.dataTerminoFolha) : null,
                    dataInicioAdiantamentoFolha: dadosEmpresa.dataInicioAdiantamentoFolha ? dayjs(dadosEmpresa.dataInicioAdiantamentoFolha) : null,
                    terminoAdiantamento: dadosEmpresa.dataTerminoAdiantamentoFolha ? dayjs(dadosEmpresa.dataTerminoAdiantamentoFolha) : null,


                    fatorR: dadosEmpresa.fatorR,



                    // Checkboxes e Booleanos (devem vir como true/false)
                    adiantamentoFolha: dadosEmpresa.adiantamentoFolha,
                    adicionalNoturno: dadosEmpresa.adicionalNoturno,
                    apontamento: dadosEmpresa.apontamento,
                    apuracaoConfiavel: dadosEmpresa.apuracaoConfiavel,
                    apuracaoDCTFWebManual: dadosEmpresa.apuracaoDCTFWebManual,
                    apuracaoManual: dadosEmpresa.apuracaoManual,
                    cargaNFSeAutomatica: dadosEmpresa.cargaNFSeAutomatica,
                    cargaNFes: dadosEmpresa.cargaNFes,
                    cestaBasica: dadosEmpresa.cestaBasica,
                    cnaeAnexos: dadosEmpresa.cnaeAnexos != "" ? dadosEmpresa.cnaeAnexos : null,
                    snanexo: dadosEmpresa.snanexo != "" ? dadosEmpresa.snanexo : null,
                    contabilidadeSimplificada: dadosEmpresa.contabilidadeSimplificada,
                    dirbi: dadosEmpresa.dirbi,
                    esocial: dadosEmpresa.esocial,
                    faturamentoExcedido: dadosEmpresa.faturamentoExcedido,
                    folha: dadosEmpresa.folha,
                    gia: dadosEmpresa.gia,
                    irFolha: dadosEmpresa.irfolha, // Mapeando 'irfolha' para 'irFolha'
                    proLabore: dadosEmpresa.prolabore, // Mapeando 'prolabore' para 'proLabore'
                    procuracaoFGTS: dadosEmpresa.procuracaoFGTS,
                    retencaoInss: dadosEmpresa.retencaoINSS, // Mapeando 'retencaoINSS' para 'retencaoInss'
                    semMovimento: dadosEmpresa.semMovimento,
                    sieg: dadosEmpresa.sieg,
                    sintegra: dadosEmpresa.sintegra,
                    vinculoSefaz: dadosEmpresa.vinculoSefaz,
                    vr: dadosEmpresa.vr,
                    vt: dadosEmpresa.vt,

                    // Outros campos
                    contribuicaoIe: dadosEmpresa.contribuicaoIe,
                    contribuicaoIm: dadosEmpresa.contribuicaoIm,
                    dataBase: dataBaseValue,
                    descontoVR: dadosEmpresa.descontoVR,
                    descontoVT: dadosEmpresa.descontoVT,
                    diaLimiteApontamento: dadosEmpresa.diaLimiteApontamento,
                    diaLimiteFolha: dadosEmpresa.diaLimiteFolha,
                    faixaFaturamento: dadosEmpresa.faixaFaturamento,
                    formaAtuacao: dadosEmpresa.formaAtuacao,
                    horaExtra: dadosEmpresa.horaExtra,
                    ie: dadosEmpresa.ie,
                    im: dadosEmpresa.im,
                    nivelContabil: dadosEmpresa.nivelContabil,
                    nivelFiscal: dadosEmpresa.nivelFiscal,
                    notificacaoCargaNFes: dadosEmpresa.notificacaoCargaNFes,
                    numeroFuncionarios: dadosEmpresa.numeroFuncionarios,
                    numeroFuncionariosIsentos: dadosEmpresa.numeroFuncionariosIsentos,
                    observacaoDP: dadosEmpresa.observacaoDP,
                    pisoSalarial: formatValueBrl(dadosEmpresa.pisoSalarial),
                    situacaoIe: dadosEmpresa.situacaoIe,
                    situacaoIm: dadosEmpresa.situacaoIm,
                    sindicatoEmpregados: dadosEmpresa.sindicatoEmpregados,
                    sindicatoPatronal: dadosEmpresa.sindicatoPatronal,
                    valorAdicional: formatValueBrl(dadosEmpresa.valorAdicional),
                    valorAssinatura: formatValueBrl(dadosEmpresa.valorAssinatura),
                    valorCestaBasica: formatValueBrl(dadosEmpresa.valorCestaBasica),
                    valorMensal: formatValueBrl(dadosEmpresa.valorMensal),

                    // Endereço (extraído de dadosEmpresa.endereco)
                    cep: dadosEmpresa.endereco ? dadosEmpresa.endereco.cep : null,
                    logradouro: dadosEmpresa.endereco ? dadosEmpresa.endereco.logradouro : null,
                    numero: dadosEmpresa.endereco ? dadosEmpresa.endereco.numero : null,
                    complemento: dadosEmpresa.endereco ? dadosEmpresa.endereco.complemento : null,
                    bairro: dadosEmpresa.endereco ? dadosEmpresa.endereco.bairro : null,
                    cidade: dadosEmpresa.endereco ? dadosEmpresa.endereco.cidade : null,
                    uf: dadosEmpresa.endereco ? dadosEmpresa.endereco.uf : null,

                    // Matriz/Filial (Assumindo que você usa o campo 'matriz' na API e mapeia para 'tipoCnpj' no form)
                    tipoCnpj: dadosEmpresa.matriz ? 'matriz' : 'filial',
                };

                form.setFieldsValue(dadosParaForm);

                municipioListar(dadosEmpresa.endereco.uf);

                if (dadosEmpresa.contribuicaoIe) {
                    setEsconderSituacaoIE(dadosEmpresa.contribuicaoIe === 'C');
                }
                if (dadosEmpresa.contribuicaoIm) {
                    setEsconderSituacaoIM(dadosEmpresa.contribuicaoIm === 'C');
                }
            } else {
                message.warning("Nenhum dado encontrado para a empresa.");
            }
        } catch (error) {
            console.error("Erro ao buscar analistas:", error);
        }
    }, [form, setEsconderSituacaoIE, setEsconderSituacaoIM]);

    const municipioListar = useCallback(async (ufSigla) => {
        if (!ufSigla) {
            console.warn("UF não fornecida, pulando listagem de municípios.");
            return [];
        }

        try {
            const url = "ibge/municipio/listar";
            const data = {
                uf: {
                    sigla: ufSigla
                }
            }
            const response = await Method_POST_CONTEXTO(url, data);
            return response;

        } catch (error) {
            console.error("Erro ao buscar carteiras:", error);
        }
    }, []);

    useEffect(() => {
        if (clienteSelecionado) {
            console.log("Iniciando carregamento do contexto...");
            contexto()
                .then(() => {

                    console.log("Contexto carregado. Chamando demais funções dependentes...");
                    consultar();
                    listCarteira();
                    listEquipe();
                }).catch(error => {
                    console.error("Erro ao carregar o contexto:", error);
                })
        }

    }, [clienteSelecionado, listCarteira, listEquipe, consultar]);

    const onFinish = (values) => {
        atualizar(values)
    };

    const handleContribuicaoIeChange = (value) => {
        setEsconderSituacaoIE(value === 'C');
    }

    const handleContribuicaoImChange = (value) => {
        setEsconderSituacaoIM(value === 'C');
    }

    const uploadProps = {
        action: '/upload.do',
        showUploadList: false,
    };

    const calcular = async (values) => {
        const dataAtual = new Date();

        const dataSituacaoFormatada = dataAtual.toISOString();

        const tipoEmpresaMap = {
            "MEI": "EI",
            "ME": "EI",
            "EPP": "EI",
            "NORMAL": "EI",

            "PA": "PA",
            "PL": "PA",

            "default": "EI"
        };

        let tipoID = tipoEmpresaMap[values.enquadramento] || tipoEmpresaMap.default;

        if (values.tipoEmpresa === "LTDA") {
            tipoID = "LTDA";
        }




        try {
            const url = `ordem-servico/assinatura/calcular`;
            const data = {

                tipo: {
                    id: "1"
                },
                situacao: {
                    id: "S"
                },
                dataSituacao: dataSituacaoFormatada,
                empresa: {
                    tipo: {
                        id: tipoID,
                    },

                    segmento: {
                        id: values.segmentoEmpresa === null || values.segmentoEmpresa === "" ? "" : values.segmentoEmpresa
                    },
                    regimeTributario: {
                        id: values.regimeTributario
                    },
                    faturamento: values.faixaFaturamento,
                    quantidadeFuncionarios: values.numeroFuncionarios,
                    simplesNacional: values.regimeTributario !== "SN" ? false : true, // ESSA CONDICIONAL AQUI É MEIO SUSPEITA, ACHO QUE NÃO ESTÁ CERTO, TEM QUE VER DIREITINHO COMO FUNCIONA
                }
            }

            console.log("Payload:", data);


            const response = await POST_MERP_REST(url, data);

            form.setFieldsValue({
                valorMensal: response.valorMensal,
                valorAssinatura: response.valorAssinatura,
                valorAdicional: response.valorAdicional
            });


            message.success("Calculo efetuado com sucesso!");

        } catch (error) {
            console.error("Erro ao atualizar dados da empresa:", error);
            message.error("Erro ao atualizar dados da empresa. Verifique o console para detalhes.");
        }
    }

    const handleConfirm = () => {
        const { fieldName, newValue } = pendingChange;

        if (fieldName === 'enquadramento') {

            const enquadramentoConfirmado = newValue;
            let novoRegimeTributarioId = form.getFieldValue('regimeTributario');
            let novaFaixaFaturamento = form.getFieldValue('faixaFaturamento');

            if (enquadramentoConfirmado === "MEI") {
                novoRegimeTributarioId = "SIMEI";
                novaFaixaFaturamento = 81000;

            } else if (enquadramentoConfirmado === "PL" || enquadramentoConfirmado === "PA") {
                novoRegimeTributarioId = "RA";
                novaFaixaFaturamento = 1440000;

            } else if (enquadramentoConfirmado === "ME" || enquadramentoConfirmado === "EPP" || enquadramentoConfirmado === "NORMAL") {
                novoRegimeTributarioId = "SN";
                novaFaixaFaturamento = form.getFieldValue('faixaFaturamento');

            }

            form.setFieldsValue({
                enquadramento: enquadramentoConfirmado,
                regimeTributario: novoRegimeTributarioId,
                faixaFaturamento: novaFaixaFaturamento,
            });

            calcular(form.getFieldsValue());
        }

        else if (fieldName === 'regimeTributario') {
            const regimeTributario = newValue;
            let novoEnquadramento = form.getFieldValue('enquadramento');
            let novaFaixaFaturamento = form.getFieldValue('faixaFaturamento');

            if (regimeTributario === "SIMEI") {
                novoEnquadramento = "MEI";
                novaFaixaFaturamento = 81000;
            } else if (regimeTributario === "RA") {
                novoEnquadramento = "PA";
                novaFaixaFaturamento = 1440000;
            }

            form.setFieldsValue({
                enquadramento: regimeTributario,
                enquadramento: novoEnquadramento,
                faixaFaturamento: novaFaixaFaturamento,
            });
            calcular(form.getFieldsValue());
        }

        else if (fieldName === 'segmentoEmpresa') {
            form.setFieldsValue({
                segmentoEmpresa: newValue,
                tipoEmpresa: "LTDA"
            });

            calcular(form.getFieldsValue());
        }

        else if (fieldName === 'faixaFaturamento') {
            form.setFieldsValue({
                faixaFaturamento: newValue,
            });

            calcular(form.getFieldsValue());
        }

        setOpenPopconfirm(false);
        setPendingChange({ fieldName: undefined, newValue: undefined, currentValue: undefined });
    };

    const handleCancel = () => {
        const { fieldName, currentValue } = pendingChange;

        if (fieldName && currentValue !== undefined) {
            form.setFieldsValue({
                [fieldName]: currentValue,
            });
        }

        setOpenPopconfirm(false);
        setPendingChange({ fieldName: undefined, newValue: undefined, currentValue: undefined });
    };

    const handleKeyDown = (e) => {
        if (e.keyCode === 13) {
            e.preventDefault();
        }
    };

    const formatInputCep = (e) => {
        const { value } = e.target;
        let numericValue = value.replace(/\D/g, '');
        if (numericValue.length > 5) {
            numericValue = numericValue.replace(/^(\d{5})(\d)/, '$1-$2');
        }
        if (numericValue.length > 9) {
            numericValue = numericValue.substring(0, 9);
        }
        form.setFieldsValue({ cep: numericValue });
    }

    return (
        <>
            <span>Mantenha os dados de sua empresa sempre atualizados.</span>
            <div style={{ padding: '24px' }}>
                <Form
                    key={clienteSelecionado}
                    form={form}
                    name="form_horizontal"
                    onFinish={onFinish}
                    onKeyDown={handleKeyDown}
                    layout="vertical"
                >

                    <Row gutter={24} className='container-cont-fiscal'>
                        <Col span={24}>
                            <Row gutter={16} style={{ maxWidth: 1024, margin: "0 auto" }}>
                                <Col span={6}>
                                    <Form.Item
                                        label="CNPJ"
                                        name="cnpj"
                                        rules={[{ required: true, message: 'Insira o CNPJ!' }]}
                                    >
                                        <Search
                                            onSearch={buscarDadosCnpj}
                                            placeholder="CNPJ"
                                            enterButton
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Form.Item label="Tipo CNPJ" name="tipoCnpj" initialValue="matriz">
                                        <Radio.Group>
                                            <Radio value="matriz">Matriz</Radio>
                                            <Radio value="filial">Filial</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Form.Item label="Carteira Cliente" name="carteira">
                                        <Select
                                            style={{ width: '100%' }}
                                            placeholder="Selecione a Carteira"
                                            options={carteirasOptions}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Form.Item label="Equipe" name="equipe">
                                        <Select
                                            style={{ width: '100%' }}
                                            placeholder="Selecione a Equipe"
                                            options={equipesOptions}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={16} style={{ maxWidth: 1024, margin: "0 auto" }}>
                                <Col span={6}>
                                    <Form.Item
                                        label="NIRE/Cartório"
                                        name="nire"
                                    >
                                        <Input placeholder="NIRE" />
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Form.Item label="Contribuinte Estadual (ICMS)" name="contribuicaoIe">
                                        <Select
                                            style={{ width: '100%' }}
                                            onChange={handleContribuicaoIeChange}
                                            options={[
                                                { value: 'C', label: 'Contribuinte' },
                                                { value: 'N', label: 'Não Contribuinte' },
                                                { value: 'I', label: 'Isento' },
                                            ]}
                                            placeholder="Selecione"
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Form.Item
                                        label="Inscrição Estadual"
                                        name="ie"
                                    >
                                        <Input placeholder={esconderSituacaoIE === false ? "NÃO CONTRIBUINTE" : "Inscrição Estadual"} disabled={esconderSituacaoIE === false ? "C" : null} />
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    {esconderSituacaoIE && (
                                        <Form.Item label="Situação IE" name="situacaoIe">
                                            <Select
                                                style={{ width: '100%' }}
                                                options={[
                                                    { value: 'A', label: 'Ativa' },
                                                    { value: 'I', label: 'Inativa' },
                                                    { value: 'S', label: 'Suspensa' },
                                                    { value: 'N', label: 'Inapta' },
                                                ]}
                                                placeholder="Selecione"
                                            />
                                        </Form.Item>
                                    )}
                                </Col>
                            </Row>

                            <Row gutter={16} style={{ maxWidth: 1024, margin: "0 auto" }}>
                                <Col span={6}></Col>

                                <Col span={6}>
                                    <Form.Item label="Contribuinte Municipal (ISS)" name="contribuicaoIm">
                                        <Select
                                            style={{ width: '100%' }}
                                            onChange={handleContribuicaoImChange}
                                            options={[
                                                { value: 'C', label: 'Contribuinte' },
                                                { value: 'N', label: 'Não Contribuinte' },
                                                { value: 'I', label: 'Isento' },
                                            ]}
                                            placeholder="Selecione"
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Form.Item
                                        label="Inscrição Municipal"
                                        name="im"
                                    >
                                        <Input placeholder={esconderSituacaoIM === false ? "NÃO CONTRIBUINTE" : "Inscrição Municipal"} disabled={esconderSituacaoIM === false ? "C" : null} />
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    {esconderSituacaoIM && (
                                        <Form.Item label="Situação IM" name="situacaoIm">
                                            <Select
                                                style={{ width: '100%' }}
                                                options={[
                                                    { value: 'A', label: 'Ativa' },
                                                    { value: 'I', label: 'Inativa' },
                                                    { value: 'S', label: 'Suspensa' },
                                                    { value: 'N', label: 'Inapta' },
                                                ]}
                                                placeholder="Selecione"
                                            />
                                        </Form.Item>
                                    )}
                                </Col>
                            </Row>

                            <Row gutter={16} style={{ maxWidth: 1024, margin: "0 auto" }}>
                                <Col span={12}>
                                    <Form.Item
                                        label="Razão Social"
                                        name="razaoSocial"
                                        rules={[{ required: true, message: 'Insira a Razão Social!' }]}
                                    >
                                        <Input placeholder="Razão Social" />
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Form.Item
                                        label="Data Constituição"
                                        name="dataConstituicao"
                                    >
                                        <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY"/>
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Form.Item
                                        label="Data Encerramento"
                                        name="dataEncerramento"
                                    >
                                        <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY"/>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={16} style={{ maxWidth: 1024, margin: "0 auto" }}>
                                <Col span={24}>
                                    <Form.Item
                                        label="Nome Fantasía"
                                        name="nomeFantasia"
                                    >
                                        <Input placeholder="Nome Fantasía" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={16} style={{ maxWidth: 1024, margin: "0 auto" }}>
                                <Col span={6}>
                                    <Form.Item label="Tipo de Empresa" name="tipoEmpresa">
                                        <Select
                                            style={{ width: '100%' }}
                                            options={[
                                                { value: 'MEI', label: 'MEI - Microempreendedor Individual' },
                                                { value: 'EI', label: 'EI - Empresário Individual' },
                                                { value: 'LTDA', label: 'LTDA - Empresa de Sociedade Limitada' },
                                                { value: 'SA', label: 'SA - Sociedade Anônima' },
                                                { value: 'PA', label: 'PA - Profissional Autônomo' },

                                                { value: 'S/S', label: 'S/S - Sociedade Simples' },
                                                { value: '3220', label: '3220 - Organizações Religiosas' },
                                                { value: '3990', label: '3990 - Associações Privadas' },
                                            ]}
                                            placeholder="Selecione"
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Popconfirm
                                        placement="top"
                                        title="Atenção"
                                        description={
                                            <>
                                                <p>
                                                    Alteração do enquadramento, regime tributário, segmento de atuação ou faixa de faturamento da empresa implicará na atualização do valor da assinatura da mensalidade.
                                                </p>

                                                <strong>
                                                    Deseja atualizar o valor da mensalidade?
                                                    ATENÇÃO: Será necessário salvar os dados do cliente para gravar o novo valor.
                                                </strong>
                                            </>
                                        }
                                        open={openPopconfirm && pendingChange.fieldName === 'enquadramento'}
                                        onConfirm={handleConfirm}
                                        onCancel={handleCancel}
                                        okText="Sim"
                                        cancelText="Não"
                                        overlayStyle={{ width: 350 }}
                                    >
                                        <Form.Item label="Enquadramento" name="enquadramento">
                                            <Select
                                                style={{ width: '100%' }}
                                                options={[
                                                    { value: 'MEI', label: 'MEI - MicroEmpreendedor Individual' },
                                                    { value: 'ME', label: 'ME - MicroEmpresa' },
                                                    { value: 'EPP', label: 'EPP - Empresa de Pequeno Porte' },
                                                    { value: 'NORMAL', label: 'Normal' },
                                                    { value: 'PA', label: 'PA - Profissional Autônomo' },
                                                    { value: 'PL', label: 'PL - Profissional Liberal' },
                                                ]}
                                                placeholder="Selecione"
                                                onChange={handleEnquadramentoChange}
                                            />
                                        </Form.Item>
                                    </Popconfirm>
                                </Col>

                                <Col span={4}>
                                    <Form.Item label="Data Enquadramento" name="dataReenquadramento">
                                        <DatePicker style={{ width: "100%" }}  format="DD/MM/YYYY"/>
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Popconfirm
                                        placement="top"
                                        title="Atenção"
                                        description={
                                            <>
                                                <p>
                                                    Alteração do enquadramento, regime tributário, segmento de atuação ou faixa de faturamento da empresa implicará na atualização do valor da assinatura da mensalidade.
                                                </p>

                                                <strong>
                                                    Deseja atualizar o valor da mensalidade?
                                                    ATENÇÃO: Será necessário salvar os dados do cliente para gravar o novo valor.
                                                </strong>
                                            </>
                                        }
                                        open={openPopconfirm && pendingChange.fieldName === 'regimeTributario'}
                                        onConfirm={handleConfirm}
                                        onCancel={handleCancel}
                                        okText="Sim"
                                        cancelText="Não"
                                        overlayStyle={{ width: 350 }}
                                    >
                                        <Form.Item label="Regime Tributário" name="regimeTributario">
                                            <Select
                                                style={{ width: '100%' }}
                                                options={[
                                                    { value: 'SIMEI', label: 'SIMEI - Sistema de Recolhimento MEI' },
                                                    { value: 'SN', label: 'SN - Simples Nacional' },
                                                    { value: 'LP', label: 'LP - Lucro Pressumido' },
                                                    { value: 'LR', label: 'LR - Lucro Real' },
                                                    { value: 'RA', label: 'RA - Regime de Autônomo' },
                                                ]}
                                                placeholder="Selecione"
                                                onChange={handleRegimeTributarioChange}
                                            />
                                        </Form.Item>
                                    </Popconfirm>
                                </Col>

                                <Col span={6}>
                                    <Form.Item label="Data Simples Nacional" name="dataOpcaoSN">
                                        <DatePicker style={{ width: "100%" }}  format="DD/MM/YYYY"/>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={16} style={{ maxWidth: 1024, margin: "0 auto" }}>
                                <Col span={6}>
                                    <Form.Item label="Capital Social" name="capitalSocial">
                                        <Input placeholder="Capital Social" />
                                    </Form.Item>
                                </Col>

                                <Col span={10}>
                                    <Popconfirm
                                        placement="top"
                                        title="Atenção"
                                        description={
                                            <>
                                                <p>
                                                    Alteração do enquadramento, regime tributário, segmento de atuação ou faixa de faturamento da empresa implicará na atualização do valor da assinatura da mensalidade.
                                                </p>

                                                <strong>
                                                    Deseja atualizar o valor da mensalidade?
                                                    ATENÇÃO: Será necessário salvar os dados do cliente para gravar o novo valor.
                                                </strong>
                                            </>
                                        }
                                        open={openPopconfirm && pendingChange.fieldName === 'segmentoEmpresa'}
                                        onConfirm={handleConfirm}
                                        onCancel={handleCancel}
                                        okText="Sim"
                                        cancelText="Não"
                                        overlayStyle={{ width: 350 }}
                                    >
                                        <Form.Item label="Segmento Atuação" name="segmentoEmpresa">
                                            <Select
                                                style={{ width: '100%' }}
                                                options={[
                                                    { value: 'PS', label: 'Empresa Prestadora de Serviços' },

                                                    { value: 'PSC', label: 'Empresa Prestadora de Serviços e Comércio' },
                                                    { value: 'PSI', label: 'Empresa Prestadora de Serviços e Indústria' },
                                                    { value: 'PSCI', label: 'Empresa Prestadora de Serviços, Comércio e Indústria' },
                                                    { value: 'C', label: 'Comércio' },
                                                    { value: 'I', label: 'Indústria' },
                                                    { value: 'CI', label: 'Comércio e Indústria' },
                                                ]}
                                                placeholder="Selecione"
                                                onChange={handleSegmentoAtuacaoChange}
                                            />
                                        </Form.Item>
                                    </Popconfirm>
                                </Col>

                                <Col span={8}>
                                    <Form.Item label="Categoria de Serviços" name="categoriaEmpresa">
                                        <Select
                                            style={{ width: '100%' }}
                                            options={[
                                                { value: 'SS', label: 'Serviços de Saúde' },
                                                { value: 'SI', label: 'Serviços Imobiliários' },
                                                { value: 'CC', label: 'Serviços de Construção Civil' },
                                                { value: 'CO', label: 'Coworking' },
                                                { value: 'NA', label: 'Outros' },
                                            ]}
                                            placeholder="Selecione"
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={10}>
                                    <Popconfirm
                                        placement="top"
                                        title="Atenção"
                                        description={
                                            <>
                                                <p>
                                                    Alteração do enquadramento, regime tributário, segmento de atuação ou faixa de faturamento da empresa implicará na atualização do valor da assinatura da mensalidade.
                                                </p>

                                                <strong>
                                                    Deseja atualizar o valor da mensalidade?
                                                    ATENÇÃO: Será necessário salvar os dados do cliente para gravar o novo valor.
                                                </strong>
                                            </>
                                        }
                                        open={openPopconfirm && pendingChange.fieldName === 'faixaFaturamento'}
                                        onConfirm={handleConfirm}
                                        onCancel={handleCancel}
                                        okText="Sim"
                                        cancelText="Não"
                                        overlayStyle={{ width: 350 }}
                                    >
                                        <Form.Item label="Faixa de Faturamento" name="faixaFaturamento">
                                            <Select
                                                style={{ width: '100%' }}
                                                options={[
                                                    { value: '', label: 'Selecione', disabled: true },
                                                    { value: 720000, label: 'Até R$ 60.000,00' },
                                                    { value: 1440000, label: 'de R$ 60.000,01 até R$ 120.000,00' },
                                                    { value: 2400000, label: 'de R$ 120.000,01 até R$ 200.000,00' },
                                                    { value: 6000000, label: 'de R$ 200.000,01 até R$ 500.000,00' },
                                                    { value: 12000000, label: 'de R$ 500.000,01 até R$ 1.000.000,00' },
                                                    { value: 12000012, label: 'Acima de R$ 1.000.000,01' },
                                                    { value: 81000, label: "Até R$ 81.000,00 Anual", disabled: true }
                                                ]}
                                                disabled={isFaturamentoDisabled}
                                                placeholder="Selecione"
                                                onChange={handleFaixaFaturamentoChange}
                                            />
                                        </Form.Item>
                                    </Popconfirm>
                                </Col>

                                <Col span={6}>
                                    <Form.Item label="Forma de Atuação" name="formaAtuacao">
                                        <Select
                                            style={{ width: '100%' }}
                                            options={[
                                                { value: 'E', label: 'Estabelecido' },
                                                { value: 'NE', label: 'Não Estabelecido' },
                                            ]}
                                            placeholder="Selecione"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <br />

                    <Row gutter={24} className='container-cont-fiscal'>
                        <Col span={24}>
                            <Row gutter={16} style={{ maxWidth: 1024, margin: "0 auto" }}>
                                <Col span={24}>
                                    <div className='color-green'>
                                        <h2>Endereço</h2>
                                    </div>
                                </Col>
                            </Row>

                            <Row gutter={16} style={{ maxWidth: 1024, margin: "0 auto" }}>
                                <Col span={6}>
                                    <Form.Item
                                        label="CEP"
                                        name="cep"
                                    >
                                        <Search
                                            placeholder="CEP"
                                            onSearch={(value) => buscaCep(value)}
                                            loading={loadingSearchCep}
                                            enterButton
                                            maxLength={9}

                                            onChange={(e) => {formatInputCep(e)}}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={4}>
                                    <Form.Item
                                        label="Inscrição Imobiliária"
                                        name="ib"
                                    >
                                        <Input placeholder="Inscrição Imobiliária" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={16} style={{ maxWidth: 1024, margin: "0 auto" }}>
                                <Col span={10}>
                                    <Form.Item
                                        label="Logradouro"
                                        name="logradouro"
                                    >
                                        <Input placeholder="Logradouro" />
                                    </Form.Item>
                                </Col>

                                <Col span={4}>
                                    <Form.Item
                                        label="Número"
                                        name="numero"
                                    >
                                        <Input placeholder="Número" />
                                    </Form.Item>
                                </Col>

                                <Col span={10}>
                                    <Form.Item
                                        label="Complemento"
                                        name="complemento"
                                    >
                                        <Input placeholder="Complemento" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={16} style={{ maxWidth: 1024, margin: "0 auto" }}>
                                <Col span={8}>
                                    <Form.Item
                                        label="Bairro"
                                        name="bairro"
                                    >
                                        <Input placeholder="Bairro" />
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Form.Item
                                        label="Cidade"
                                        name="cidade"
                                    >
                                        <Input placeholder="Cidade" />
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Form.Item
                                        label="UF"
                                        name="uf"
                                    >
                                        <Select
                                            placeholder="Selecione o o Estado (UF)"
                                            style={{ width: '100%' }}
                                            options={ufOptions}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>


                        </Col>
                    </Row>

                    <br />

                    <Row gutter={24} className='container-cont-fiscal'>
                        <Col span={24}>
                            <Row gutter={24} className='container-cont-fiscal'>

                                <Col span={12}>
                                    <div className='color-green'>
                                        <h2>Contábil</h2>
                                    </div>

                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label="Nível Contábil" name="nivelContabil">
                                                <Select
                                                    placeholder="Selecione o Nível"
                                                    style={{ width: '100%' }}
                                                    options={[
                                                        { value: '', label: 'Selecionar', disabled: true },
                                                        { value: 'B', label: 'Baixo' },
                                                        { value: 'M', label: 'Médio' },
                                                        { value: 'A', label: 'Alto' },
                                                    ]}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={12}>
                                            <Form.Item label="Regime Contábil" name="regimeContabil">
                                                <Select
                                                    placeholder="Selecione o Regime"
                                                    style={{ width: '100%' }}
                                                    options={[
                                                        { value: 'CX', label: 'Caixa' },
                                                        { value: 'CP', label: 'Competência' },
                                                    ]}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <Form.Item name="contabilidadeSimplificada" valuePropName="checked">
                                                <Checkbox>Contabilidade Simplificada</Checkbox>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col span={12}>
                                    <div className='color-green'>
                                        <h2>Fiscal</h2>
                                    </div>

                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label="Nível Fiscal" name="nivelFiscal">
                                                <Select
                                                    placeholder="Selecione o Nível"
                                                    style={{ width: '100%' }}
                                                    options={[
                                                        { value: '', label: 'Selecionar', disabled: true },
                                                        { value: 'B', label: 'Baixo' },
                                                        { value: 'M', label: 'Médio' },
                                                        { value: 'A', label: 'Alto' },
                                                    ]}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={12}>
                                            <Form.Item label="Data Última Notificação" name="dataNotificacaoCargaNFes">
                                                <DatePicker style={{ width: "100%" }} disabled  format="DD/MM/YYYY"/>
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={12}>

                                            <Form.Item name="cnaeAnexos" label="CNAE Anexos" style={{ marginBottom: 8 }}>
                                                <Input disabled={!form.cnaeAnexos} placeholder="CNAE Anexos" />
                                            </Form.Item>




                                            <Form.Item name="snanexo" label="Anexo Considerado" style={{ marginBottom: 8 }}>
                                                <Input disabled />
                                            </Form.Item>

                                            {form.regimeApuracao === null || form.regimeApuracao === "" ? null : <>
                                                <Form.Item name="regimeApuracao" label="Regime Considerado" style={{ marginBottom: 8 }}>
                                                    <Input />
                                                </Form.Item>
                                            </>}

                                            <Form.Item name="fatorR" valuePropName="checked" style={{ marginBottom: 8 }}>
                                                <Checkbox>Fator R</Checkbox>
                                            </Form.Item>

                                            <Form.Item name="cargaNFSeAutomatica" valuePropName="checked" style={{ marginBottom: 8 }}>
                                                <Checkbox>Carga NFSe Automática</Checkbox>
                                            </Form.Item>

                                            <Form.Item name="sintegra" valuePropName="checked" style={{ marginBottom: 8 }}>
                                                <Checkbox>Sintegra</Checkbox>
                                            </Form.Item>

                                            <Form.Item name="semMovimento" valuePropName="checked" style={{ marginBottom: 8 }}>
                                                <Checkbox>Empresa Sem Movimento</Checkbox>
                                            </Form.Item>

                                            <Form.Item name="apuracaoManual" valuePropName="checked" style={{ marginBottom: 8 }}>
                                                <Checkbox>Apuração Manual (Fiscal)</Checkbox>
                                            </Form.Item>

                                            <Form.Item name="motivoApuracaoManual" style={{ marginBottom: 8 }}>
                                                <Select
                                                    options={[
                                                        { value: '', label: 'Selecionar' },
                                                        { value: 'M-NF-PORTAL', label: 'Carga de NF no Portal' },

                                                        { value: 'M-NF-CI', label: 'Emissão NF Comércio/Indústria' },

                                                        { value: 'M-NF-MANUAL', label: 'Emissão NF Manual' },
                                                        { value: 'M-NF-EXT', label: 'Emissão NF Exterior' },
                                                        { value: 'M-NF-RETR', label: 'Emissão NF Retroativo' },

                                                        { value: 'M-ALUGUEL', label: 'Aluguél' },
                                                        { value: 'M-ISS-RET', label: 'ISS Retido' },
                                                        { value: 'M-COMP-CX', label: 'Empresa de Competência Caixa' },
                                                        { value: 'M-REINF', label: 'Empresa com REINF' },

                                                        { value: 'M-VL-ALTO', label: 'Empresa de Alto Valor' },
                                                        { value: 'M-CRITICO', label: 'Empresa de Alta Criticidade' },
                                                    ]}
                                                    placeholder="Carga de NF no Portal"
                                                />
                                            </Form.Item>

                                            <Form.Item name="apuracaoDCTFWebManual" valuePropName="checked" style={{ marginBottom: 0 }}>
                                                <Checkbox>Apuração Manual (DCTF Web)</Checkbox>
                                            </Form.Item>

                                            <Form.Item name="dirbi" valuePropName="checked" style={{ marginBottom: 0 }}>
                                                <Checkbox>Elegível DIRBI</Checkbox>
                                            </Form.Item>

                                            <Form.Item name="gia" valuePropName="checked" style={{ marginBottom: 0 }}>
                                                <Checkbox>Elegível GIA</Checkbox>
                                            </Form.Item>
                                        </Col>

                                        <Col span={12}>
                                            <Form.Item name="retencaoInss" valuePropName="checked" style={{ marginBottom: 8 }}>
                                                <Checkbox>Retenção INSS</Checkbox>
                                            </Form.Item>

                                            <Form.Item name="irFolha" valuePropName="checked" style={{ marginBottom: 8 }}>
                                                <Checkbox>IR Folha</Checkbox>
                                            </Form.Item>

                                            <Form.Item name="cargaNFes" valuePropName="checked" style={{ marginBottom: 8 }}>
                                                <Checkbox>Carga de NFe</Checkbox>
                                            </Form.Item>

                                            <Form.Item name="notificacaoCargaNFes" valuePropName="checked" style={{ marginBottom: 0 }}>
                                                <Checkbox>Notificação Carga NFe</Checkbox>
                                            </Form.Item>

                                            <Form.Item name="faturamentoExcedido" valuePropName="checked" style={{ marginBottom: 0 }}>
                                                <Checkbox>Faturamento Excedido</Checkbox>
                                            </Form.Item>

                                            <Form.Item name="vinculoSefaz" valuePropName="checked" style={{ marginBottom: 0 }}>
                                                <Checkbox>Vínculo SEFAZ</Checkbox>
                                            </Form.Item>

                                            <Form.Item name="sieg" valuePropName="checked" style={{ marginBottom: 0 }}>
                                                <Checkbox>Cadastrada SIEG</Checkbox>
                                            </Form.Item>

                                            <Form.Item name="apuracaoConfiavel" valuePropName="checked" style={{ marginBottom: 30 }}>
                                                <Checkbox disabled>Apuração Confiável (Fiscal)</Checkbox>
                                            </Form.Item>

                                            <Form.Item name="motivoApuracaoConfiavel" style={{ marginBottom: 8 }}>
                                                <Input placeholder='Selecionar' disabled />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <br />

                    <Row gutter={24} className='container-cont-fiscal'>
                        <Col span={12}>
                            <h2>Departamento pessoal</h2>
                            <Row gutter={22}>
                                <Col span={8}>
                                    <Form.Item label="Regime DP" name="regimeDp" style={{ marginBottom: 0 }}>
                                        <Select
                                            options={[
                                                { value: 'CP', label: 'Competência' },
                                                { value: 'CX', label: 'Caixa' },
                                            ]}
                                            placeholder="Selecione o Regime"
                                            style={{ width: '100%' }}
                                        />
                                    </Form.Item>

                                    <Form.Item name="proLabore" valuePropName="checked" style={{ marginBottom: 8 }}>
                                        {/* O Checkbox é o componente de controle */}
                                        <Checkbox disabled>
                                            Pró-Labore
                                            {/* Coloque o Tooltip *após* o texto do Checkbox e envolva o ícone */}
                                            <Tooltip
                                                title={
                                                    <>
                                                        <strong>Ajuda - Pró-Labore</strong>
                                                        <p style={{ margin: 0 }}>
                                                            Para alterar a situação, valor ou vigência do Pró-Labore dos sócios desta empresa, acesse a opção "Sócios" no menu "Departamento Pessoal".
                                                        </p>
                                                    </>
                                                }
                                            >
                                                <QuestionCircleOutlined style={{ color: '#1890ff', marginLeft: 8 }} />
                                            </Tooltip>
                                        </Checkbox>
                                    </Form.Item>

                                    <Form.Item name="folha" valuePropName="checked" style={{ marginBottom: 8 }}>
                                        <Checkbox disabled>Folha-Pagamento</Checkbox>
                                    </Form.Item>

                                    <Form.Item name="adiantamentoFolha" valuePropName="checked" style={{ marginBottom: 8 }}>
                                        <Checkbox>Adiantamento Folha</Checkbox>
                                    </Form.Item>

                                    <Form.Item name="apontamento" valuePropName="checked" style={{ marginBottom: 0 }}>
                                        <Checkbox>Apontamento</Checkbox>
                                    </Form.Item>

                                    <Form.Item name="procuracaoFGTS" valuePropName="checked" style={{ marginBottom: 0 }}>
                                        <Checkbox>Procuração FGTS</Checkbox>
                                    </Form.Item>

                                    <Form.Item name="esocial" valuePropName="checked" style={{ marginBottom: 0 }}>
                                        <Checkbox>e-Social</Checkbox>
                                    </Form.Item>

                                    <Form.Item name="vr" valuePropName="checked" style={{ marginBottom: 0 }}>
                                        <Checkbox>Vale Refeição</Checkbox>
                                    </Form.Item>

                                    <Form.Item name="vt" valuePropName="checked" style={{ marginBottom: 0 }}>
                                        <Checkbox>Vale Transporte</Checkbox>
                                    </Form.Item>

                                    <Form.Item name="cestaBasica" valuePropName="checked" style={{ marginBottom: 0 }}>
                                        <Checkbox>Cesta Básicas</Checkbox>
                                    </Form.Item>
                                </Col>

                                <Col span={16}>
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label="Início Pró-Labore" name="dataInicioProlabore" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                <DatePicker style={{ width: "100%" }} disabled  format="DD/MM/YYYY"/>
                                            </Form.Item>
                                        </Col>

                                        <Col span={12}>
                                            <Form.Item label="Término Pró-Labore" name="dataTerminoProlabore" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                <DatePicker style={{ width: "100%" }} disabled  format="DD/MM/YYYY"/>
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label="Início Folha" name="inicioFolha" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                <DatePicker style={{ width: "100%" }} disabled  format="DD/MM/YYYY"/>
                                            </Form.Item>
                                        </Col>

                                        <Col span={12}>
                                            <Form.Item label="Término Folha" name="dataTerminoFolha" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                <DatePicker style={{ width: "100%" }} disabled  format="DD/MM/YYYY"/>
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label="Início Adiantamento" name="dataInicioAdiantamentoFolha" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                <DatePicker style={{ width: "100%" }}  format="DD/MM/YYYY"/>
                                            </Form.Item>
                                        </Col>

                                        <Col span={12}>
                                            <Form.Item label="Término Adiantamento" name="terminoAdiantamento" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                <DatePicker style={{ width: "100%" }}  format="DD/MM/YYYY"/>
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label="Início Procuração FGTS" name="dataInicioProcuracaoFGTS" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                <DatePicker style={{ width: "100%" }}  format="DD/MM/YYYY"/>
                                            </Form.Item>
                                        </Col>

                                        <Col span={12}>
                                            <Form.Item label="Término Procuração FGTS" name="dataTerminoProcuracaoFGTS" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                <DatePicker style={{ width: "100%" }}  format="DD/MM/YYYY"/>
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label="Nº Funcionários" name="numeroFuncionarios" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                <Input placeholder='Número Funcionários' style={{ width: "100%" }} />
                                            </Form.Item>
                                        </Col>

                                        <Col span={12}>
                                            <Form.Item label="Funcionários Isentos" name="numeroFuncionariosIsentos" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                <Input placeholder='Funcionários Isentos' style={{ width: "100%" }} disabled />
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label="Dia Pagamento Folha" name="diaLimiteFolha" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                <Input placeholder='Dia Pagamento Folha' style={{ width: "100%" }} />
                                            </Form.Item>
                                        </Col>

                                        <Col span={12}>
                                            <Form.Item label="Dia Receb.Apontam" name="diaLimiteApontamento" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                <Input placeholder='Dia Receb.Apontamentos' style={{ width: "100%" }} />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <br />

                    <Row gutter={24} className='container-cont-fiscal'>
                        <Col span={24}>
                            <h2>Sindicato</h2>
                            <Row gutter={16}>
                                <Col span={6}>
                                    <Form.Item label={<span>Sindicato Patronal {/**<LinkOutlined style={{ color: '#1890ff' }} /> */}</span>} name="sindicatoPatronal">
                                        <Input />
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Form.Item label={<span>Sindicato Empregados {/*<LinkOutlined style={{ color: '#1890ff' }} />*/}</span>} name="sindicatoEmpregados">
                                        <Input />
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Form.Item label="Data Base" name="dataBase">
                                        <Select placeholder="Selecione" options={mesesOptions} />
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Form.Item label="Piso Salarial" name="pisoSalarial">
                                        <Input addonBefore="R$" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Form.Item
                                label="Carregue o arquivo de enquadramento sindical da empresa:"
                                name="enquadramentoSindical"
                            >
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ flexGrow: 1, padding: '4px 10px', backgroundColor: '#f5f5f5', border: '1px solid #d9d9d9', borderRight: 'none', borderRadius: '6px 0 0 6px' }}>
                                        <span style={{ color: '#bfbfbf' }}>Nenhum arquivo selecionado</span>
                                    </div>

                                    <Upload {...uploadProps}>
                                        <Button type="primary" style={{ borderRadius: '0 6px 6px 0' }} disabled>
                                            Selecionar...
                                        </Button>
                                    </Upload>
                                </div>
                            </Form.Item>
                        </Col>
                    </Row>

                    <br />

                    <Row gutter={24} className='container-cont-fiscal'>
                        <Col span={24}>
                            <h2>Benefícios</h2>
                            <Row gutter={16}>
                                <Col span={5}>
                                    <Form.Item label="Hora Extra" name="horaExtra">
                                        <Input style={{ width: '100%' }} disabled />
                                    </Form.Item>
                                </Col>

                                <Col span={5}>
                                    <Form.Item label="Adicional Noturno" name="adicionalNoturno">
                                        <Input style={{ width: '100%' }} disabled />
                                    </Form.Item>
                                </Col>

                                <Col span={5}>
                                    <Form.Item label="Desconto VR" name="descontoVR">
                                        <Input style={{ width: '100%' }} disabled />
                                    </Form.Item>
                                </Col>

                                <Col span={5}>
                                    <Form.Item label="Desconto VT" name="descontoVT">
                                        <Input style={{ width: '100%' }} disabled />
                                    </Form.Item>
                                </Col>

                                <Col span={4}>
                                    <Form.Item label="Cesta Básica" name="valorCestaBasica">
                                        <Input style={{ width: '100%' }} disabled />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={16} style={{ padding: 5 }}>
                                <Form.Item label="Observação" name="observacaoDP" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                    <TextArea rows={4} style={{ width: 985 }} />
                                </Form.Item>
                            </Row>
                        </Col>
                    </Row>

                    <br />

                    <Row gutter={24} className='container-cont-fiscal'>
                        <Col span={24}>
                            <h2>Mensalidade de Serviço</h2>
                            <Row gutter={16}>
                                <Col span={6}>
                                    <Form.Item label="Valor Mensal" name="valorMensal">
                                        <Input style={{ width: '100%' }} disabled/>
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Form.Item label="Valor Assinatura" name="valorAssinatura">
                                        <Input style={{ width: '100%' }} disabled />
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Form.Item label="Valor Adicional" name="valorAdicional">
                                        <Input style={{ width: '80%' }} disabled />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Row style={{ maxWidth: 1000, margin: "20px auto 0 auto" }}>
                        <Col span={24} style={{ textAlign: 'right' }}>
                            <Button type="primary" htmlType="submit">
                                Salvar Alterações
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    );
};

export default AtualizarDadosEmpresa;